export const PERMISSION_RESOURCE_CODES = {
  permission: 'permission',
  topic: 'research-topics',
  company: 'research-companies',
  material: 'research-materials',
  viewpoint: 'research-viewpoints',
} as const;

export const PERMISSION_ACTION_CODES = {
  permission: {},
  topic: {
    view: 'view',
    create: 'create',
    edit: 'edit',
    manage: 'manage',
  },
  company: {
    view: 'view',
    create: 'create',
    edit: 'edit',
    manage: 'manage',
  },
  material: {
    view: 'view',
    create: 'create',
    edit: 'edit',
    manage: 'manage',
  },
  viewpoint: {
    view: 'view',
    create: 'create',
    edit: 'edit',
    manage: 'manage',
  },
} as const;
